import React from 'react';
import logo from '../../../assets/images/logo.png';
import { Link } from 'react-router-dom';
import { ADMIN_ROOT_PATH } from '../../../constants/routes';
import Navigation from './Navigation';

const Header = ({ logOut, currentPath }) => (
    <header className="ckp-admin-header">
        <Link to={ADMIN_ROOT_PATH} className="ckp-admin-header-logo">
            <img src={logo} alt="Logo" className="ckp-admin-header-logo-image" />
        </Link>
        <Navigation logOut={logOut} currentPath={currentPath} />
    </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/admin/layout/Header.js